import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ResetPassword.css';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    const [requirements, setRequirements] = useState({
        length: false,
        uppercase: false,
        number: false,
        special: false,
        match: false
    });

    useEffect(() => {
        if (!token) {
            setMessage('Geen token gevonden.');
        }
    }, [token]);

    const validatePassword = (pw, confirm) => {
        setRequirements({
            length: pw.length >= 8,
            uppercase: /[A-Z]/.test(pw),
            number: /\d/.test(pw),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(pw),
            match: pw === confirm
        });
    };

    useEffect(() => {
        validatePassword(password, confirmPassword);
    }, [password, confirmPassword]);

    const handleReset = async (e) => {
        e.preventDefault();

        if (Object.values(requirements).includes(false)) {
            setMessage('Wachtwoord voldoet niet aan de eisen.');
            return;
        }

        try {
            setIsSubmitting(true);
            const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/reset-password`, {
                token,
                password
            });
            setMessage(res.data.message);
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setMessage(err.response?.data?.error || 'Fout bij resetten wachtwoord');
        } finally {
            setIsSubmitting(false);
        }
    };

    const checkClass = (condition) => (condition ? 'valid' : 'invalid');

    return (
        <div className="reset-password-container form-container-custom">
            <h2>Nieuw wachtwoord instellen</h2>
            {message && <p className="info-message">{message}</p>}

            <form onSubmit={handleReset}>
                <div className="form-group password-group">
                    <label>Nieuw wachtwoord</label>
                    <div className="password-input-wrapper">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                        <i
                            className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} password-toggle-icon`}
                            onClick={() => setShowPassword(prev => !prev)}
                            title={showPassword ? 'Verberg wachtwoord' : 'Toon wachtwoord'}
                        ></i>
                    </div>
                </div>

                <div className="form-group password-group">
                    <label>Bevestig wachtwoord</label>
                    <div className="password-input-wrapper">
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                        />
                        <i
                            className={`bi ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'} password-toggle-icon`}
                            onClick={() => setShowConfirmPassword(prev => !prev)}
                            title={showConfirmPassword ? 'Verberg wachtwoord' : 'Toon wachtwoord'}
                        ></i>
                    </div>
                </div>

                <ul className="requirements">
                    <li className={checkClass(requirements.length)}>Minimaal 8 tekens</li>
                    <li className={checkClass(requirements.uppercase)}>Minimaal 1 hoofdletter</li>
                    <li className={checkClass(requirements.number)}>Minimaal 1 cijfer</li>
                    <li className={checkClass(requirements.special)}>Minimaal 1 speciaal teken</li>
                    <li className={checkClass(requirements.match)}>Wachtwoorden komen overeen</li>
                </ul>

                <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Bezig...' : 'Wachtwoord resetten'}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
